import {
    DMARC_AUTHENTICATION_FAILURE,
    DMARC_AUTHENTICATION_REQUEST,
    DMARC_AUTHENTICATION_SUCCESS
} from './types/dmarc-authentication-action-types';
import { prevDmarcAuthParamsSelector } from '../selectors/dmarc-auth-selectors';

import ReportService from '../../common/services/reports-service';
import axios from 'axios';
import { isEqual } from 'lodash';

function requestDmarcAuthentication( params ){
    return {
        params,
        type: DMARC_AUTHENTICATION_REQUEST,
    };
}

function receiveDmarcAuthentication( data ){
    return {
        payload: data,
        type: DMARC_AUTHENTICATION_SUCCESS,
    };
}

function dmarcAuthenticationError( error ){
    return {
        error,
        type: DMARC_AUTHENTICATION_FAILURE,
    };
}

function fetchDmarcAuthentication( params ){
    return ( dispatch, getState, { DATA_API } ) => {
        dispatch( requestDmarcAuthentication( params ) );

        const reportService = new ReportService( DATA_API );
        return reportService.getDmarcAuthentication( params )
            .then(
                ( response ) => dispatch( receiveDmarcAuthentication( response.data ) ),
                ( error = {} ) => {
                    if( !axios.isCancel( error ) ){
                        return dispatch( dmarcAuthenticationError( error.response ) );
                    }
                }
            );
    };
}

export function fetchDmarcAuthenticationIfNeeded( params ){
    return ( dispatch, getState ) => {
        const state = getState();
        const prevParams = prevDmarcAuthParamsSelector( state );
        if( !isEqual( params, prevParams ) ){
            return dispatch( fetchDmarcAuthentication( params ) );
        }
        else{
            return Promise.resolve();
        }
    };
}
